import { createContext, useState } from "react";

export const RelatorioProdutosContext = createContext();

export const RelatorioProdutosProvider = ({ children }) => {
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [report, setReport] = useState(null);

    return (
        <RelatorioProdutosContext.Provider value={{
            startDate, setStartDate, endDate, setEndDate, report, setReport
        }}>
            {children}
        </RelatorioProdutosContext.Provider>
    );
};
